import { Skeleton } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const ServiceAccountDetailsFormSkeleton: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h4>{t('service_account:technician_info')}</h4>
      <section>
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
      </section>
      <h4>{t('service_account:company_info')}</h4>
      <section>
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <div />
      </section>
      <h4>{t('common:access')}</h4>
      <section>
        <Skeleton animation="wave" variant="text" width={184} />
        <Skeleton animation="wave" variant="text" width={184} />
      </section>
      <h4>{t('service_account:account_status')}</h4>
      <section>
        <Skeleton animation="wave" variant="text" width={184} />
        <Skeleton animation="wave" variant="text" width={184} />
      </section>
      <h4>{t('service_account:other_information')}</h4>
      <Skeleton animation="wave" variant="rectangular" height={128} />
    </>
  );
};

export default ServiceAccountDetailsFormSkeleton;
